import { defineMessages, FormattedMessage } from 'react-intl';

type Unit = 'mm' | 'inch';

const prefix = 'shoppingBagStrapDetails';

export const defined = defineMessages({
  availableSize: {
    defaultMessage: 'Available size',
    id: `shoppingBagStrapDetails.strapDrawer.availableSize`,
  },
  addACompatibleBuckle: {
    defaultMessage: 'Get a buckle for your strap',
    id: `shoppingBagStrapDetails.strapDrawer.addACompatibleBuckle`,
  },
  buckleOutOfStock: {
    defaultMessage: 'Buckles are out of stock',
    id: `shoppingBagStrapDetails.strapDrawer.buckleOutOfStock`,
  },
});

export const NiceToHavetext = (
  <FormattedMessage
    defaultMessage='The perfect tool to easily change a strap on your Breitling. Use the forked end to release the spring bar from the lugs, and to place the buckle on your new strap when needed.'
    id={`${prefix}.niceToHaveText`}
  />
);

export const MeasuringText = (min: number, max: number, unit: Unit) => (
  <FormattedMessage
    defaultMessage='Fits a wrist measuring between {min} and {max} {unit}'
    id='shoppingBagStrapDetails.strapDrawer.measuringText'
    values={{ min, max, unit }}
  />
);
